export default __webpack_public_path__ + "static/tiempos-text-web-medium-e7888aa49506eaf2b5022707aa2d9649.woff2";